export default {
  setProfile (state, payload) {
    state.profile = payload
  },
  setIntegrations (state, payload) {
    state.integrations = payload
  }
}
